// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 785) return "static/chunks/785-a789b4c985fb6a90.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "cc1e672cb7313e3f" + ".js";
};